import React, { Component } from "react";
import styled from "styled-components";

const scale = 16;

const Preview = styled.div`
  & > canvas {
    width: 100%;
    image-rendering: optimizeSpeed;
    image-rendering: -moz-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: -o-crisp-edges;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
  }
`;

interface Props {
  data: string;
}

class DesignPreview extends Component<Props> {
  canvas: React.RefObject<HTMLCanvasElement>;

  constructor(props: Props) {
    super(props);
    this.canvas = React.createRef();
  }
  componentDidMount() {
    this.updateCanvas(this.props.data);
  }

  updateCanvas(data: string) {
    const canvas = this.canvas.current;
    const ctx = canvas.getContext("2d");

    const rows = data.match(/.{1,192}/g);
    for (const row in rows) {
      const columns = rows[row].match(/.{1,6}/g);
      for (const column in columns) {
        ctx.fillStyle = "#" + columns[column];
        const r = parseInt(row);
        const c = parseInt(column);
        ctx.fillRect(
          c * scale,
          r * scale,
          c * scale + scale,
          r * scale + scale
        );
      }
    }
  }

  render() {
    return (
      <Preview>
        <canvas ref={this.canvas} width={32 * scale} height={32 * scale} />
      </Preview>
    );
  }
}

export default DesignPreview;
